import React from "react";
import "./commonRadio.css";
const CommonRadio = ({ label, options, selectedValue, handleRadioChange }) => {
  return (
    <div className="radio-check">
      <label className="custom-radio-label">{label}</label>
      <div className="radiofield">
        {options.map((option) => (
          <div className="form-check mr-3" key={option.value}>
            <input
              type="radio"
              id={option.value}
              name="address" // Ensure radio buttons share the same name to group them
              className="form-check-input"
              checked={selectedValue === option.label} // Check if the current option is selected
              onChange={() => handleRadioChange(option)} // Pass the value of the selected option
            />
            <label htmlFor={option.value} className="form-check-label">
              <p className="item" style={{ fontWeight: "bold" }}>{option?.label}</p>
              <span style={{ fontStyle: "regular", color: "gray" }}>
                {option?.value}
              </span>
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CommonRadio;
